import { Action } from "../../../types/state/action";
import {
  IGlobalProduct,
  ILicensedProperty,
  ILicensor,
  IRequestStatusReason,
  TccRequestStatus,
} from "../../../types/data.interface";
import { Option } from "../../tcc-searches/data.type";

type ValueOrNull<T> = T | null;

export interface IMasterArtworkRequestHistory {
  status: TccRequestStatus;
  timestamp: string;
  user: string;
  comment: string;
  rejectReason: IRequestStatusReason;
}

export type MasterArtworkCollectionState = {
  id?: number | string;
  name: string;
  code: string;
  licensor: ValueOrNull<ILicensor>;
  licensed_property: ValueOrNull<ILicensedProperty>;
  launch_date: string;
  global_product: ValueOrNull<IGlobalProduct[]>;

  requestId: string;
  requestStatus: ValueOrNull<string>;
  requestDateFrom: string;
  requestDateTo: string;
  requestor: string;
  approvedDateFrom: string;
  approvedDateTo: string;
  approver: string;

  requestHistory: IMasterArtworkRequestHistory;

  status?: string;
  comment?: string;
  isValid:ValueOrNull<boolean>
  isReadOnly:boolean

  submitComment: string;
  approveComment: string;
  rejectComment: string;
  rejectReason: IRequestStatusReason | null;

  hasUnsavedChanges: boolean;
};

export enum MasterArtworkCollectionActionTypes {
  SET_COLLECTION ="masterArtworkCollection/setCollection",
  SET_GLOBAL_PRODUCT = "masterArtworkCollection/setGlobalProduct",
  SET_LICENSOR = "masterArtworkCollection/setLicensor",
  SET_LICENSED_PROPERTY = "masterArtworkCollection/setLicensedProperty",
  SET_NAME = "masterArtworkCollection/setName",
  SET_CODE = "masterArtworkCollection/setCode",
  SET_LAUNCH_DATE = "masterArtworkCollection/setLaunchDate",
  RESET_STATE ="masterArtworkCollection/resetState",


  SET_REQUEST_STATUS = "masterArtworkCollection/setRequestStatus",
  SET_IS_VALID = "masterArtworkCollection/setIsValid",
  SET_REQUEST_ID = "masterArtworkCollection/setRequestId",
  SET_REVISION = "masterArtworkCollection/setRevision",
  SET_REQUEST_DATE = "masterArtworkCollection/setRequestDate",
  SET_REQUESTER = "masterArtworkCollection/setRequester",
  SET_APPROVED_DATE = "masterArtworkCollection/setApprovedDate",
  SET_APPROVER = "masterArtworkCollection/setApprover",

  ADD_REQUEST_HISTORY = "masterArtworkCollection/addRequestHistory",

  SET_SUBMIT_COMMENT = "masterArtworkCollection/setSubmitComment",
  SET_APPROVE_COMMENT = "masterArtworkCollection/setApproveComment",
  SET_REJECT_COMMENT = "masterArtworkCollection/setRejectComment",
  SET_REJECT_REASON = "masterArtworkCollection/setRejectReason",
  //
  // SET_REQUEST_SPECIFIC_DETAILS = "masterArtworkCollection/setRequestSpecificDetails",
  // SET_REQUEST_DATA = "masterArtworkCollection/setRequestData",
  // SET_REQUEST_DETAILS_AFTER_ACTION = "masterArtworkCollection/setRequestDetailsAfterAction",
  // RESET = "masterArtworkCollection/reset",
  SET_UNSAVED_CHANGES = "masterArtworkCollection/serUnsavedChanges",
  SET_IS_READ_ONLY = "masterArtworkCollection/setIsReadOnly",

  SET_FILTERS_FROM_STORAGE = "masterArtworkCollection/setFiltersFromStorage",
  RESET = "masterArtworkCollection/reset",

}

export type MasterArtworkCollectionActionType = Action<
  MasterArtworkCollectionActionTypes,
  Partial<MasterArtworkCollectionState>
>;
